import React from 'react';
import styled from 'styled-components';

import { viewerZIndices } from '../../../../viewer/viewer-z-indices';
import { RightMenuAutoExpandContainer } from './right-menu-auto-expand-container';

const RightMenu = () => {
  return <Component />;
};

const Component = styled(RightMenuAutoExpandContainer)`
  z-index: ${viewerZIndices.menu};
`;

export { RightMenu, Component as RightMenuStyled };
